/** Report catalogue and grouping for the class Reports tab (no React, no API). */

const RESTRICTED_ROLES = ["COURSE_COORDINATOR", "ADMIN", "GLOBAL_ADMIN", "BUREAU"];

export const REPORTS = [
  { id: "attendance", group: "assessment", icon: "calendar", title: "Attendance summary",
    description: "Session attendance by student, including present and missing status for each class meeting." },
  { id: "tests", group: "assessment", icon: "test", title: "Test results summary",
    description: "Written test outcomes by student, including score, passing status, attempts and submission time." },
  { id: "skills", group: "assessment", icon: "clip", title: "Skill check sheet results",
    description: "Practical skill sheet outcomes by student, evaluator, result and grade percentage." },
  { id: "completion", group: "completion", icon: "award", title: "Completion readiness",
    description: "Student readiness for sign-off based on prerequisites, attendance, tests and required skill sheets." },
  { id: "incomplete", group: "completion", icon: "alert", title: "Incomplete requirements",
    description: "At-risk student list showing missing attendance, failed tests and required skill sheets not yet passed." },
  { id: "coi_compliance", group: "compliance", icon: "shield", title: "Insurance (COI) compliance", restricted: true,
    description: "COI status for registered students. Restricted to coordinators, admins and bureau users." },
];

export const GROUPS = [
  { key: "assessment", label: "Attendance and assessment" },
  { key: "completion", label: "Completion" },
  { key: "compliance", label: "Compliance" },
];

export const canViewRestrictedReports = (roles) =>
  Array.isArray(roles) && roles.some((role) => RESTRICTED_ROLES.includes(role));

/** Reports the given roles may see, in display groups; empty groups are dropped. */
export function groupReports(roles) {
  const allowed = REPORTS.filter((r) => !r.restricted || canViewRestrictedReports(roles));
  return GROUPS.map((g) => ({ ...g, reports: allowed.filter((r) => r.group === g.key) })).filter((g) => g.reports.length > 0);
}

export const reportCountLabel = (n) => `${n} report${n === 1 ? "" : "s"}`;

export function downloadErrorMessage(err) {
  return err?.response?.data?.error || err?.message || "Report download failed.";
}
